var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from "react-router-dom";
export default function Link(_a) {
    var href = _a.href, children = _a.children, props = __rest(_a, ["href", "children"]);
    if (href.startsWith('http') || href.startsWith('#') || href.startsWith('mailto')) {
        return (React.createElement(MuiLink, __assign({ href: href }, props), children));
    }
    return (React.createElement(MuiLink, __assign({ component: RouterLink, to: href }, props), children));
}
